import {
  OrganizationCodes,
  ORGANIZATION_LOGOS,
  BankCodesForAll,
  ORGANIZATION_LOGOS_FOR_ALL,
} from '../models';

export function getOrganizationLogo(bankCode: OrganizationCodes) {
  return (
    ORGANIZATION_LOGOS[bankCode] || {
      x1: 'https://static.clobe.ai/image/etc-bank.png',
      x2: 'https://static.clobe.ai/image/etc-bank.png',
    }
  );
}

export function getOrganizationLogoForAll(bankCode?: BankCodesForAll) {
  if (!bankCode) {
    return {
      x2: 'https://static.clobe.ai/image/etc-bank.png',
      x1: 'https://static.clobe.ai/image/etc-bank.png',
    };
  }
  return ORGANIZATION_LOGOS_FOR_ALL[bankCode];
}
